module.exports = __webpack_public_path__ + "static/media/42x38-10.e5b77aeb.png";